import React from "react";

import ModalBase from "./ModalBase";
import AdminAddOrganization from "../AdminAddOrganization";

interface CreateOrganizationModalProps {
  /** Provided by ModalGlobal — closes the modal. */
  onClose: (result?: any) => void;
}

// Thin ModalBase shell around the existing admin form, so the Admin page opens it as a modal instead of an inline card
const CreateOrganizationModal: React.FC<CreateOrganizationModalProps> = ({ onClose }) => (
  <ModalBase title="Create Organization" onClose={() => onClose()} size="md">
    <AdminAddOrganization onCompleted={() => onClose()} />
  </ModalBase>
);

export default CreateOrganizationModal;
